// Optional host capabilities. The shared vector canvas must not import portal auth/API clients.
import { inject, provide, type ComputedRef, type InjectionKey } from 'vue';

export type ThemeTokens = Record<string, string>;
export const documentThemeKey: InjectionKey<ComputedRef<ThemeTokens | undefined>> = Symbol('document-theme');
export function provideDocumentTheme(tokens: ComputedRef<ThemeTokens | undefined>) { provide(documentThemeKey, tokens); }

export interface CanvasHost {
  theme?: { load(): Promise<void>; resolve(value: unknown): unknown };
  embed?: typeof import('./SynEmbed.vue')['default'];
  alarm?: typeof import('./AlarmBanner.vue')['default'];
  map?: typeof import('./SynMap.vue')['default'];
  chart?: typeof import('./SynChart.vue')['default'];
}
export const canvasHostKey: InjectionKey<CanvasHost> = Symbol('canvas-host');
export function useCanvasHost(): CanvasHost { return inject(canvasHostKey, {}); }
export function useCanvasTheme() {
  const host = useCanvasHost(), scoped = inject(documentThemeKey, undefined);
  return {
    // A captured document owns its theme; no tenant lookup is needed for it.
    load: () => scoped ? Promise.resolve() : host.theme?.load() ?? Promise.resolve(),
    resolve: (value: unknown) => {
      if (typeof value !== 'string' || !value.startsWith('token:')) return value;
      return scoped?.value?.[value.slice(6)] ?? host.theme?.resolve(value) ?? value;
    },
  };
}
